import apiClient, {
  apiClientForOutSourcing,
} from "../../../utils/lib/apiClient";
import { loadingState, loadingText } from "../../../states/loadingState";
import { useSetRecoilState } from "recoil";
export const useGetAddressList = () => {
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);

  const getToAddressList = async (workerId: string, factoryId: string) => {
    setLoadingAnimation(true);
    setLoadingText("検索中...");
    try {
      const res = await apiClientForOutSourcing.get(`/address/to-address`, {
        params: {
          workerId: workerId || undefined,
          factoryId: factoryId || undefined,
        },
      });

      const data = res.data;
      if (data[0] !== "") return res.data;

      return null;
    } catch (e) {
      window.alert(`エラーが発生しました${e}`);
      return null;
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };
  const getCcAddressList = async (workerId: string, factoryId: string) => {
    setLoadingAnimation(true);
    setLoadingText("検索中...");
    try {
      const res = await apiClientForOutSourcing.get(`/address/cc-address`, {
        params: {
          workerId: workerId || undefined,
          factoryId: factoryId || undefined,
        },
      });

      const data = res.data;
      if (data[0] !== "") return res.data;

      return null;
    } catch (e) {
      window.alert(`エラーが発生しました${e}`);
      return null;
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };

  return { getToAddressList, getCcAddressList };
};
